<app-table *ngIf="tableConfig" [config]="tableConfig"/>
